import { request } from "admin/libs/openapi";

export const requestPasswordReset = async ({ email }: { email: string }) => {
  return await request("post", "/admin/password_reset/request", {
    body: { email },
  }).then(() => ({ success: true }));
};
